<app-page
  [flush]="true"
  pageTitle="Podešavanja"
  pageDescription="Podaci i podešavanja naloga"
>
  <hr class="settings-divider" />
  <div class="settings-wrapper">
    <!-- Individual summary header -->
    <div class="user-summary flex align-items-center gap-3">
      <div class="user-summary__avatar">
        <app-user-circle stroke="#414651" width="24px" height="24px"></app-user-circle>
      </div>
      <div class="flex flex-column gap-1 min-w-0">
        <div class="display-xs-semibold text-gray-900">{{ headerName() }}</div>
        <div class="flex flex-wrap align-items-center gap-3 text-sm-regular text-gray-600">
          @if (headerEmail()) {
            <div class="flex align-items-center gap-1">
              <app-mail-01 stroke="#ADB0B8" width="14px" height="14px"></app-mail-01>
              <div class="text-sm-medium text-gray-600">{{ headerEmail() }}</div>
            </div>
          }
          <div class="flex align-items-center gap-1">
            <app-phone stroke="#ADB0B8" width="14px" height="14px"></app-phone>
            <div class="text-sm-medium text-gray-600">{{ headerPhone() || '-' }}</div>
          </div>
        </div>
      </div>
    </div>

    <hr class="settings-divider" />

    <div class="settings-body">
      <!-- Side nav -->
      <nav class="settings-nav flex flex-column gap-1">
        @for (section of SECTIONS; track section.key) {
          <button
            type="button"
            class="settings-nav__item text-sm-semibold"
            [class.settings-nav__item--active]="isActive(section.key)"
            (click)="setSection(section.key)"
          >
            {{ section.label }}
          </button>
        }
      </nav>

      <!-- Section content -->
      <div class="settings-content">
        @if (isActive('basic')) {
          <div class="section-header">
            <div class="text-lg-semibold text-gray-900">Osnovni podaci</div>
            <div class="text-sm-regular text-gray-600">Informacije koje se koriste i za kreiranje fakture</div>
          </div>
          <hr class="settings-divider" />

          <div class="form-grid">
            <div class="form-grid__label text-sm-semibold text-gray-900">Ime</div>
            <app-field for="basic-first-name" styleClass="form-grid__control">
              <app-text-input
                [hasIcon]="true"
                formCtrlId="basic-first-name"
                ctrlPlaceholder="Ime"
                [formCtrl]="infoForm.controls.firstName"
              >
                <app-user-circle stroke="#ADB0B8"></app-user-circle>
              </app-text-input>
            </app-field>

            <div class="form-grid__label text-sm-semibold text-gray-900">Prezime</div>
            <app-field for="basic-last-name" styleClass="form-grid__control">
              <app-text-input
                [hasIcon]="true"
                formCtrlId="basic-last-name"
                ctrlPlaceholder="Prezime"
                [formCtrl]="infoForm.controls.lastName"
              >
                <app-user-circle stroke="#ADB0B8"></app-user-circle>
              </app-text-input>
            </app-field>

            <div class="form-grid__label text-sm-semibold text-gray-900">Adresa</div>
            <!-- Figma: one label, three stacked inputs. On mobile Grad / Poštanski broj get their own labels. -->
            <div class="form-grid__control flex flex-column gap-3">
              <div class="flex flex-column gap-2">
                <app-field for="basic-address">
                  <app-text-input
                    [hasIcon]="true"
                    formCtrlId="basic-address"
                    ctrlPlaceholder="Ulica i broj"
                    [formCtrl]="infoForm.controls.address"
                  >
                    <app-home-line stroke="#ADB0B8"></app-home-line>
                  </app-text-input>
                </app-field>
              </div>
              <div class="flex flex-column gap-2">
                <div class="address-sublabel text-sm-semibold text-gray-900">Grad</div>
                <app-field for="basic-city">
                  <app-text-input
                    [hasIcon]="true"
                    formCtrlId="basic-city"
                    ctrlPlaceholder="Grad"
                    [formCtrl]="infoForm.controls.city"
                  >
                    <app-marker-pin-01 stroke="#ADB0B8"></app-marker-pin-01>
                  </app-text-input>
                </app-field>
              </div>
              <div class="flex flex-column gap-2">
                <div class="address-sublabel text-sm-semibold text-gray-900">Poštanski broj</div>
                <app-field for="basic-postal">
                  <app-text-input
                    [hasIcon]="true"
                    formCtrlId="basic-postal"
                    ctrlPlaceholder="Poštanski broj"
                    [formCtrl]="infoForm.controls.postalCode"
                  >
                    <app-map-01 stroke="#ADB0B8"></app-map-01>
                  </app-text-input>
                </app-field>
              </div>
            </div>
          </div>

          <hr class="settings-divider" />
          <div class="flex justify-content-end">
            <app-button
              [btnSize]="ButtonSize.MD"
              [btnSeverity]="ButtonSeverity.PRIMARY"
              (btnClicked)="saveInfo()"
            >
              <div class="text-sm-semibold text-white">Sačuvaj izmene</div>
            </app-button>
          </div>
        }

        @if (isActive('contact')) {
          <div class="section-header">
            <div class="text-lg-semibold text-gray-900">Kontakt informacije</div>
            <div class="text-sm-regular text-gray-600">Email i telefon za kontakt</div>
          </div>
          <hr class="settings-divider" />

          <div class="form-grid">
            <div class="form-grid__label text-sm-semibold text-gray-900">Email</div>
            <app-field for="contact-email" styleClass="form-grid__control">
              <app-text-input
                [hasIcon]="true"
                formCtrlId="contact-email"
                ctrlPlaceholder="Email"
                [formCtrl]="infoForm.controls.email"
              >
                <app-mail-01 stroke="#ADB0B8"></app-mail-01>
              </app-text-input>
            </app-field>

            <div class="form-grid__label text-sm-semibold text-gray-900">Telefon</div>
            <app-field for="contact-phone" styleClass="form-grid__control">
              <app-text-input
                [hasIcon]="true"
                formCtrlId="contact-phone"
                ctrlPlaceholder="Telefon"
                [formCtrl]="infoForm.controls.phone"
              >
                <app-phone stroke="#ADB0B8"></app-phone>
              </app-text-input>
            </app-field>
          </div>

          <hr class="settings-divider" />
          <div class="flex justify-content-end">
            <app-button
              [btnSize]="ButtonSize.MD"
              [btnSeverity]="ButtonSeverity.PRIMARY"
              (btnClicked)="saveInfo()"
            >
              <div class="text-sm-semibold text-white">Sačuvaj izmene</div>
            </app-button>
          </div>
        }

        @if (isActive('password')) {
          <div class="section-header">
            <div class="text-lg-semibold text-gray-900">Lozinka</div>
            <div class="text-sm-regular text-gray-600">Upravljanje lozinkom za prijavu</div>
          </div>
          <hr class="settings-divider" />

          <div class="form-grid">
            <div class="form-grid__label text-sm-semibold text-gray-900">Promeni lozinku</div>
            <div class="form-grid__control flex flex-column gap-3">
              <app-field label="Stara lozinka" for="old-password">
                <app-text-input
                  [hasIcon]="true"
                  formCtrlId="old-password"
                  formCtrlType="password"
                  [formCtrl]="passwordForm.controls.oldPassword"
                >
                  <app-lock-03 stroke="#ADB0B8"></app-lock-03>
                </app-text-input>
              </app-field>
              <app-field label="Nova lozinka" for="new-password">
                <app-text-input
                  [hasIcon]="true"
                  formCtrlId="new-password"
                  formCtrlType="password"
                  [formCtrl]="passwordForm.controls.newPassword"
                >
                  <app-lock-03 stroke="#ADB0B8"></app-lock-03>
                </app-text-input>
              </app-field>
              <app-password-requirements [password]="passwordForm.controls.newPassword.value"></app-password-requirements>
              <app-field label="Potvrdi novu lozinku" for="confirm-password">
                <app-text-input
                  [hasIcon]="true"
                  formCtrlId="confirm-password"
                  formCtrlType="password"
                  [formCtrl]="passwordForm.controls.confirmPassword"
                >
                  <app-lock-03 stroke="#ADB0B8"></app-lock-03>
                </app-text-input>
              </app-field>
            </div>
          </div>

          <hr class="settings-divider" />
          <div class="flex justify-content-end">
            <app-button
              [btnSize]="ButtonSize.MD"
              [btnSeverity]="ButtonSeverity.PRIMARY"
              (btnClicked)="savePassword()"
            >
              <div class="text-sm-semibold text-white">Sačuvaj izmene</div>
            </app-button>
          </div>
        }
      </div>
    </div>
  </div>
</app-page>
